import * as styles from './styles.css';
import {
  Checkbox as MUICheckbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
} from '@mui/material';
import FormLabel from '@mui/material/FormLabel';
import { IComponent, IOption } from '../../../interfaces';
import { useProps } from '../../../hooks/use-props';
import OtherInput from './other-input';

interface ICheckboxProps {
  id: string;
}

interface ICheckboxAtom extends IComponent {
  placeholder?: string;
  value: IOption[];
  answer: IOption[];
  error?: string;
}

export const useCheckbox = (id: string) => {
  const { props, addAnswer } = useProps<ICheckboxAtom>({ id, initial_state: [] });
  const { value } = props;
  const setValue = (new_option: IOption) => {
    const filtered_list = [...value.filter((option) => option.id !== new_option.id)];
    const options =
      filtered_list.length === value.length ? [...filtered_list, new_option] : filtered_list;
    addAnswer({ options });
  };
  const has_other = props.variant === 'other';
  return {
    props: {
      ...props,
      has_other,
    },
    setValue,
  };
};

const Checkbox = ({ id }: ICheckboxProps) => {
  const {
    props: { required, error, options, label, show, value, placeholder, has_other },
    setValue,
  } = useCheckbox(id);
  if (!show) return null;
  return (
    <FormControl id={id} className={styles.root} required={required} error={!!error}>
      <FormLabel component="legend" className={styles.label}>
        <b>{label}</b>
        <span style={{ fontWeight: 400 }}>&nbsp;(Select all that apply.)</span>
      </FormLabel>
      <FormGroup>
        {options &&
          options.map((option) => (
            <FormControlLabel
              key={`${option.id}-${option.label}`}
              control={
                <MUICheckbox
                  id={`${id}-${option.id}`}
                  checked={!!value.find((o) => o.id === option.id)}
                  onChange={() => setValue(option)}
                />
              }
              label={option.label}
            />
          ))}
        {has_other && <OtherInput id={id} label={placeholder ?? ''} />}
      </FormGroup>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export default Checkbox;
